import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { ITS_DATA_VALID_YEARS } from '../../util/ITS';

const FilterModalItsYearSelect = (props) => {
  const { option, setFieldValue } = props;
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [itsOptions, setItsOptions] = useState([]);

  useEffect(() => {
    if (!option?.value) return;
    const dataMap = option.value.map((value) => {
      return { value: value, label: value };
    });
    const itsMap = ITS_DATA_VALID_YEARS.year_txt.map((year) => {
      return { value: year, label: year };
    });
    if (dataMap.length !== itsMap.length) {
      setSelectedOptions(dataMap);
    }
    setItsOptions(itsMap);
  }, []);

  const handleOnChange = (value) => {
    let saveFormat = value.map((item) => {
      return item.value;
    });
    if (saveFormat.length == 0) {
      saveFormat = ITS_DATA_VALID_YEARS.year_txt;
    }
    setFieldValue(option.name, saveFormat);
  };

  return (
    <Form.Group id={option.name}>
      <Form.Label>
        <span>Year</span>
      </Form.Label>
      <Select
        isMulti
        value={selectedOptions || []}
        options={itsOptions || []}
        onChange={(event) => {
          setSelectedOptions(event);
          handleOnChange(event);
        }}
      />
    </Form.Group>
  );
};

export default FilterModalItsYearSelect;
